export const SLA = {
  BROKEN_SLA: { title: "Overdue", fill: "#7F5FDC", sort: 0 },
  ALMOST_BROKEN_SLA: { title: "Due Soon", fill: "#DA5CCE", sort: 1 },
  WITHIN_SLA: { title: "In Time", fill: "#6AB7DC", sort: 2 },
};

export const SLA_STATUS_NA = "NA";
